export const initVendor = (win, cap) => {
    const Ionic = (win.Ionic = win.Ionic || {});
    const IonicWebView = (Ionic.WebView = Ionic.WebView || {});
    const Plugins = cap.Plugins;
    IonicWebView.getServerBasePath = (callback) => {
        var _a;
        (_a = Plugins === null || Plugins === void 0 ? void 0 : Plugins.WebView) === null || _a === void 0 ? void 0 : _a.getServerBasePath().then(result => {
            callback(result.path);
        });
    };
    IonicWebView.setServerBasePath = (path) => {
        var _a;
        (_a = Plugins === null || Plugins === void 0 ? void 0 : Plugins.WebView) === null || _a === void 0 ? void 0 : _a.setServerBasePath({ path });
    };
    IonicWebView.persistServerBasePath = () => {
        var _a;
        (_a = Plugins === null || Plugins === void 0 ? void 0 : Plugins.WebView) === null || _a === void 0 ? void 0 : _a.persistServerBasePath();
    };
    IonicWebView.convertFileSrc = (url) => cap.convertFileSrc(url);
};
//# sourceMappingURL=vendor.js.map